import React from "react";
import "./loader.css";
const Loader = ({ className, color, style }) => {
  return (
    <div className={`flex justify-center w-full  ${className} `}>
      <div className={`loader text-[#0c4a6e] ${color} ${style}`}></div>
    </div>
  );
};

export default Loader;
